/**
 * Trigger a notification with a given payload
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
export const addNotification = ({ commit }, payload) => {
    commit('ADD_NOTIFICATION', payload)
}

/**
 * Remove a notification from the queue
 *
 * @param  {Function} options.commit
 * @param  {Object} notification
 * @return {Void}
 */
export const removeNotification = ({ commit }, notification) => {
    commit('REMOVE_NOTIFICATION', notification)
}

export const resetApplicationState = ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
        dispatch('projects/single/resetState')
        dispatch('projects/form/resetState')
        dispatch('projects/resetState')
        dispatch('portfolios/resetState')
        dispatch('user/resetState')
        commit('RESET_STATE')
        resolve()
    })
}

export default {
    addNotification,
    removeNotification,
    resetApplicationState
}



// WEBPACK FOOTER //
// ./src/state/actions.js